import { render } from "./ui-task-remove-card.vue?vue&type=template&id=83b4b6b8&scoped=true"
import script from "./ui-task-remove-card.vue?vue&type=script&lang=js"
export * from "./ui-task-remove-card.vue?vue&type=script&lang=js"

import "./ui-task-remove-card.vue?vue&type=style&index=0&id=83b4b6b8&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b4b6b8"]])

export default __exports__